export const Login = () => {
	return (
		<div className="flex flex-col center full-height">
			<div className="container flex-col center">
				<img
					src="/chartis_logo.png"
					alt="Chartis Logo"
					className="logo with-margin"
				/>
				<h1>Chartis Timesheets</h1>
				<p>Sign in with your Capsule CRM account to continue</p>
				<a href="/auth/loginURL/" className="button button-primary">
					Sign in with Capsule
				</a>
			</div>
		</div>
	);
};
